import React from 'react'
import axios from 'axios';
import Swal from "sweetalert2";

import Card from '../components/UI/Card';
import useInput from '../hooks/useInput';
import { useNavigate, useParams } from 'react-router-dom';


const PasswordNew = () => {

    const navigate = useNavigate();
    const {token} = useParams();

    // INPUT PASSWORD
    const passwordValidacion = value => value.trim() !== "" && value.length >= 6;
    const {
        value: password,
        isValid: passwordIsValid,
        isTouched: passwordIsTouched,
        valueChangeHandler: passwordChangeHanlder,
        inputBlurHandler: passwordBlurHandler,
    } = useInput(passwordValidacion);

    // CONFIRM PASSWORD
    const {
        value: confirmPassword,
        isTouched: confirmPasswordIsTouched,
        valueChangeHandler: confirmPasswordChangeHanlder,
        inputBlurHandler: confirmPasswordBlurHandler,
    } = useInput(passwordValidacion);
    const confirmPasswordIsValid = confirmPassword.trim() !== "" && password === confirmPassword;

    const formIsValid = passwordIsValid && confirmPasswordIsValid;

    const formSubmitHandler = async event => {
        event.preventDefault();

        passwordBlurHandler();
        confirmPasswordBlurHandler();

        if (!formIsValid)
            return;

        let formData = new FormData();
        formData.append('password', password);
        formData.append('confirm_password', confirmPassword);
        formData.append('token', token);
        formData.append('crearPassword', 1);

        const response = await axios.post(process.env.REACT_APP_API_URL, formData);
        const result = response.data;

        if (result.STATUS && result.STATUS === "SUCCESS") {
            Swal.fire({
                icon: 'success',
                title: '¡Contraseña guardada!',
                showConfirmButton: false,
                timer: 5000
            });
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Ocurrió un problema, intentelo más tarde',
                showConfirmButton: false,
                timer: 3500
            });
        }
        navigate('/login', { replace: true });
    }

    return (
        <div className="row">
            <div className="offset-md-3 col-md-6">
                <Card>
                    <form className="row my-5" onSubmit={formSubmitHandler}>

                        {/* LABEL TITULO */}
                        <div className="col-md-8 offset-md-2 mb-1">
                            <h1 className="display-6 mb-0" style={{ userSelect: 'none', color: 'rgba(0,0,0,0.65)', fontSize: '1.5rem' }}>Crear nueva contraseña</h1>
                        </div>

                        <div className="col-md-8 offset-md-2"><hr className="mt-0" /></div>

                        {/* PASSWORD */}
                        <div className="col-md-8 offset-md-2 mb-3 mt-1">
                            <input
                                type="password"
                                className={`mb-1 form-control form-control-sm shadow-sm ${passwordIsTouched ? ((passwordIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                value={password}
                                onChange={passwordChangeHanlder}
                                onBlur={passwordBlurHandler}
                                placeholder="Ingrese nueva contraseña" />
                            <input
                                type="password"
                                className={`form-control form-control-sm shadow-sm ${confirmPasswordIsTouched ? ((confirmPasswordIsValid) ? 'is-valid' : 'is-invalid') : ''}`}
                                value={confirmPassword}
                                onChange={confirmPasswordChangeHanlder}
                                onBlur={confirmPasswordBlurHandler}
                                placeholder="Repita la nueva contraseña" />
                            <div className="invalid-feedback" style={{ userSelect: 'none' }}>
                                <div>
                                    {!passwordIsValid && "La contraseña debe tener al menos 6 caracteres."}
                                </div>
                                <div>
                                    {!confirmPasswordIsValid && "Las contraseñas deben coincidir."}
                                </div>
                            </div>
                        </div>

                        {/* GUARDAR */}
                        <div className="col-md-8 offset-md-2 mt-3 text-center">
                            <button
                                className={`btn btn-success btn-sm`}>
                                <span style={{ display: 'flex' }}>
                                    Guardar
                                </span>
                            </button>
                        </div>
                    </form>
                </Card>
            </div>
        </div>
    )
}

export default PasswordNew